import React from 'react';
import { connect } from 'react-redux';

import AboveTheFoldOnlyServerRender from './shared/components/above-the-fold-only-server-render';
import ScripLoader from './page/components/script-loader';

class ThirdPartyTags extends React.PureComponent {
    static defaultProps = {
        marketing: [
            'https://www.googletagmanager.com/gtm.js?id=GTM-N72GKFZ',
            'https://nexus.ensighten.com/hp/udlmarketing/Bootstrap.js',
        ],
        analytics: [
            'https://hp.com/cma/ng/lib/exceptions/privacy-banner.js',
            'https://www.googletagmanager.com/gtm.js?id=GTM-MZXB4R4',
        ],
        abtesting: [],
    };

    render() {
        const { location, analytics, abtesting, marketing } = this.props;
        const { query = {} } = location || {};
        const { __disableThirdParty, __3PBuffer } = query;

        if (__disableThirdParty === '*') {
            return null;
        }

        let analyticsBuffer;
        let analyticsLoadStrategy = 'load';

        const idleBuffer = isNaN(query.__3PBuffer) ? 2000 : __3PBuffer * 1;
        const disableMarketing = __disableThirdParty === 'marketing';
        const disableABTest = __disableThirdParty === 'optly';
        const disableAnalytics = __disableThirdParty === 'udl';

        return (
            <React.Fragment>
                {!disableAnalytics && (
                    <AboveTheFoldOnlyServerRender
                        renderOn={analyticsLoadStrategy}
                        skip={true}
                        idleBuffer={analyticsBuffer}
                    >
                        {analytics.map(url => (
                            <ScripLoader key={url} url={url} />
                        ))}
                    </AboveTheFoldOnlyServerRender>
                )}
                {!disableMarketing && (
                    <AboveTheFoldOnlyServerRender renderOn={'idle'} skip={true} idleBuffer={idleBuffer}>
                        {marketing.map(url => (
                            <ScripLoader key={url} url={url} once={true} />
                        ))}
                    </AboveTheFoldOnlyServerRender>
                )}
                {!disableABTest && (
                    <AboveTheFoldOnlyServerRender renderOn={'idle'} skip={true}>
                        {abtesting.map(url => (
                            <ScripLoader key={url} url={url} once={true} />
                        ))}
                    </AboveTheFoldOnlyServerRender>
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    //possible tempory for controlling this optimization from page component
    const { router, thirdPartyTags } = state;
    const { location } = router || {};
    let { marketing, abtesting, analytics } = thirdPartyTags;
    //TODO: temporarily force defaults for these if someone accidently deletes them all from DB
    marketing = !marketing || marketing.length === 0 ? undefined : marketing;
    analytics = !analytics || analytics.length === 0 ? undefined : analytics;
    return { location, marketing, abtesting, analytics };
};

export default connect(mapStateToProps, null)(ThirdPartyTags);
